import { makeAutoObservable } from 'mobx';
import { RootStore } from '@intrasync/stores';

class DashboardStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }




}

export default DashboardStore;
